import { computed } from "vue-demi";
import { getCurrentUser } from "./currentUser.js";
const currentUserIsGroup = computed(() => {
  var _a;
  const current = getCurrentUser();
  return ((_a = current.value) == null ? void 0 : _a.orgId) === "1";
});
export { currentUserIsGroup };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/currentUserIsGroup.js